import { ROUTES } from '@/constants';

export const sidebarItems = [
	{ label: 'Presentación', to: ROUTES.COLEGIO_PRESENTACION },
	{
		label: 'Organización',
		children: [
			{ label: 'Junta Directiva', to: ROUTES.COLEGIO_JUNTA_DIRECTIVA },
			{ label: 'Departamentos', to: ROUTES.COLEGIO_DEPARTAMENTOS },
			{ label: 'Notarios', to: ROUTES.COLEGIO_NOTARIOS },
		],
	},
	{ label: 'Visita Virtual', to: ROUTES.COLEGIO_VISITA_VIRTUAL },
];

// Const sidebarSections = [
// 	{
// 		label: 'Encuentra tu notario',
// 		children: [
// 			{ label: 'Buscador de notarios', to: '' },
// 			{ label: 'Libre elección de Notario', to: '/libre-eleccion-de-notario' },
// 			{ label: 'Colegios Notariales', to: '/colegios-notariales' },
// 			{ label: 'Notarios de guardia', to: '/notarios-de-guardia' },
// 		],
// 	},
// 	{ label: 'Academia de Opositores', to: '/academia-de-opositores' },
// 	{ label: 'Corporación Notarial', to: '/corporacion-notarial' },
// 	{ label: 'Encuentra tu escritura', to: '/encuentra-tu-escritura' },
// 	{ label: 'Nuevas actuaciones notariales', to: '/actuaciones-notariales' },
// 	{ label: 'Glosario', to: '/glosario' },
// 	{ label: 'Enlaces de interés', to: '/enlaces-de-interes' },
// ];
